import { assets, icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  .togContent .static_summary button {
    padding: 8px 14px 7px 14px;
    font-weight: 400;
    background: hsla(0, 0%, 0%, 0.3);
    border: 1px solid hsla(0, 0%, 100%, 0.2);
    font-size: 0.75rem;
    margin: 0 0 0 10px;
    white-space: nowrap;
  }
  .yolocoaster_announcement {
    position: relative;
    padding: 0 0 15px 0;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  .yolocoaster_announcement .subtitle {
    font-size: 0.75rem;
    line-height: 130%;
    padding: 0 0 10px 0;
  }
  .yolocoaster_announcement .title .new_icon {
    background: url(${icons.new_icon_yc}) center center / 36px auto no-repeat;
    width: 36px;
    margin: 0 8px 0 0;
  }
  .yolocoaster_announcement .title {
    text-transform: uppercase;
    font-size: 0.9rem;
    color: #24ce44;
    font-weight: 700;
    padding: 5px 0 12px 0;
    display: flex;
    flex-direction: row;
  }
  .yolocoaster_announcement .yc_icon {
    background: url(${assets.yolocoaster_icon}) center center / 50px auto no-repeat;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
    right: 0;
  }
  .yolocoaster_announcement button.yc_select {
    margin: 0;
    background: linear-gradient(180deg, #1da737, #1ca235, #1b9d34, #1a9832, #199331, #198f2f, #188a2e, #17852c);
    border: 0;
    font-weight: 600;
    padding: 8px 14px 7px 14px;
    font-size: 0.75rem;
  }
  .yolocoaster_announcement button.yc_select:hover {
    background: linear-gradient(180deg, #17852c, #17852c, #17852c, #17852c, #17852c, #17852c, #17852c, #17852c);
  }
`

const developerCSS = css``

export const YolocoasterAnnouncementCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
